module.exports = __webpack_public_path__ + "static/media/soap.bec01134.svg";